import { useEffect, useRef, useState } from "react";

export const Loading = () => {
  const [loadingSeconds, setLoadingSeconds] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setLoadingSeconds(0);

    timerRef.current = setInterval(() => {
      setLoadingSeconds((s) => s + 1);
    }, 1000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  return (
    <div className="w-full">
      <main className="flex flex-col items-center justify-center p-6">
        <div className="flex flex-col items-center">
          <div
            className="animate-spin rounded-full h-16 w-16 border-4 border-primary border-t-transparent mb-4"
            style={{
              borderColor:
                "hsl(var(--primary)) transparent hsl(var(--primary)) hsl(var(--primary))",
            }}
          />
          <div className="text-center text-muted-foreground mb-2">
            Data is loading... this can take a couple of minutes during high
            peak times
          </div>
          <p>Loading time: {loadingSeconds} seconds</p>
        </div>
      </main>
    </div>
  );
};
